export enum PaymentFailureReason {
  CREDIT_CARD = 'CREDIT_CARD',
  TOKEN_BUY = 'TOKEN_BUY',
}
